import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import {BeatLoader} from 'react-spinners';
import {dataRegister} from "../../services/dataRegister";
import {Doughnut, Line} from 'react-chartjs-2';
import {langRegister} from "../../services/langRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {userRegister} from "../../services/userRegister";

class userCampaignsHistoryItem extends Component {


    constructor(props) {
        super(props);
        this.state = {
            data: null,
            time_indicator: true,
            show: true,
            channels_style: {
                line: {
                    instagram: {
                        title: "instagram",
                        backgroundColor: 'rgba(204, 84, 48, 0.25)',
                    },
                    fb: {
                        title: "facebook",
                        backgroundColor: 'rgba(204, 84, 48, 0.9)',
                    },
                    bing: {
                        title: "bing",
                        backgroundColor: 'rgba(204, 84, 48, 0.5)',
                    },
                    google: {
                        title: "google",
                        backgroundColor: 'rgba(145, 51, 25, 0.9)',
                    }
                },
                doughnut: {
                    instagram: {
                        title: "instagram",
                        backgroundColor: 'rgba(204, 84, 48, 0.25)',
                        hoverBackgroundColor: 'rgba(204, 84, 48, 0.25)'
                    },
                    fb: {
                        title: "facebook",
                        backgroundColor: 'rgba(204, 84, 48, 0.9)',
                        hoverBackgroundColor: 'rgba(204, 84, 48, 0.9)'
                    },
                    bing: {
                        title: "bing",
                        backgroundColor: 'rgba(204, 84, 48, 0.5)',
                        hoverBackgroundColor: 'rgba(204, 84, 48, 0.5)'
                    },
                    google: {
                        title: "google",
                        backgroundColor: 'rgba(145, 51, 25, 0.9)',
                        hoverBackgroundColor: 'rgba(145, 51, 25, 0.9)'
                    }
                }
            },
            chartData: {
                labels: ["1", "2", "3", "4", "5", "6"],
                datasets: [{
                    backgroundColor: 'rgba(204, 84, 48, 0.5)',
                    borderColor: '#CC5430',
                    data: [],
                    borderWidth: 2,
                    radius: 4,
                    pointBackgroundColor: "#ffffff",
                    pointHoverBorderColor: '#CC5430',
                    pointHoverBackgroundColor: "#ffffff",
                }]
            },
            options: {
                scales: {
                    xAxes: [
                        {
                            display: false,
                        }
                    ],
                    yAxes: [
                        {
                            display: false,
                        }
                    ]
                },
                tooltips: {
                    enabled: false
                },
                title: {
                    display: false
                },
                legend: {
                    display: false
                },
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 5,
                        bottom: 0
                    }
                }
            },
            doughnutData: {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: [],
                    borderColor: [
                        'transparent',
                        'transparent',
                        'transparent',
                        'transparent',
                    ],
                    hoverBorderColor: [
                        'transparent',
                        'transparent',
                        'transparent',
                        'transparent',
                    ],
                    hoverBackgroundColor: []
                }],
            },
            doughnutOptions: {
                scales: {
                    xAxes: [
                        {
                            display: false,
                        }
                    ],
                    yAxes: [
                        {
                            display: false,
                        }
                    ]
                },
                tooltips: {
                    enabled: false
                },
                title: {
                    display: false
                },
                legend: {
                    display: false
                },
                cutoutPercentage: 65,
                responsive: false,
                maintainAspectRatio: false,
            },
            open: false,
            chart: false,
            selected: "impressions",
            user_email: null,
            reseller: false,
            inhouse: false,
            leads: 0,
            engagement: 0,
            reactions: 0
        };
        this._updateChartData = this._updateChartData.bind(this);
    };

    componentWillMount() {
        this._setValues();
        this._updateUserData();
    }

    componentWillReceiveProps(){
        this.setState({
            data: this.props.data
        }, () => {
            this._updateChartData();
        });
    }

    _updateUserData() {
        let user = userRegister.get();
        if (user) {
            this.setState({
                user_email: user.email,
                reseller: (user.reseller || user.inhouse),
                inhouse: user.inhouse,
                user: user
            });
        }
    }

    _setValues() {
        this.setState({
            data: this.props.data
        }, () => {
            this._updateChartData();
        });
    }

    _updateChartData() {
        let datasets = [];
        this.setState({show: false});

        //test

        try {
            let value = this.state.data.total_observations;
            value++;
            this.state.chartData.labels = [];
            for(let i = 0; i < value; i++){
                this.state.chartData.labels.push(i);
            }
        }catch (e) {}

        if (this.state.open) {
            try{
                // SET LINE CHART
                let channels_observations = {};
                for(let i = 0; i < this.state.data.observations.length; i++){
                    for(let m = 0; m < this.state.data.channels.length; m++){
                        let key = this.state.data.channels[m];
                        if(channels_observations[key]){
                            if(this.state.data.observations[i].channels[key]){
                                if(this.state.selected === 'call'){
                                    try {
                                        channels_observations[key].observations.push(this.state.data.observations[i].channels[key]['details']['withExtension']['Phone calls']['clicks']?parseInt(this.state.data.observations[i].channels[key]['details']['withExtension']['Phone calls']['clicks']):0);
                                    }catch (e) {
                                        channels_observations[key].observations.push(0);
                                    }
                                }else{
                                    channels_observations[key].observations.push(this.state.data.observations[i].channels[key][this.state.selected]?parseInt(this.state.data.observations[i].channels[key][this.state.selected]):0);
                                }
                            }
                        }else{
                            if(this.state.data.observations[i].channels[key]){
                                channels_observations[key] = {backgroundColor: null, observations: [0], title: null};
                                channels_observations[key].backgroundColor = this.state.channels_style.line[key].backgroundColor;
                                channels_observations[key].title = this.state.channels_style.line[key].title;
                                channels_observations[key].observations.push(this.state.data.observations[i].channels[key][this.state.selected]?parseInt(this.state.data.observations[i].channels[key][this.state.selected]):0);
                            }
                        }
                    }
                }
                for(let m = 0; m < this.state.data.channels.length; m++){
                    try{
                        let key = this.state.data.channels[m];
                        datasets.unshift({
                            data: channels_observations[key].observations,
                            backgroundColor: channels_observations[key].backgroundColor,
                            borderColor: 'transparent',
                            radius: 0,
                            label: channels_observations[key].title
                        });
                    }catch (e) {}
                }

                // SET DOUGHNUT DATA
                let observations = [];
                let channels = {};
                for(let i = 0; i < this.state.data.observations.length; i++){
                    for(let m = 0; m < this.state.data.channels.length; m++) {
                        let key = this.state.data.channels[m];
                        if(channels[key]){
                            if(this.state.data.observations[i].channels[key] && this.state.data.observations[i].channels[key][this.state.selected]){
                                channels[key].value = channels[key].value + parseInt(this.state.data.observations[i].channels[key][this.state.selected]);
                            }else{
                                channels[key].value = channels[key].value + 0;
                            }
                        }else{
                            channels[key] = {};
                            channels[key].title = this.state.channels_style.doughnut[key].title;
                            channels[key].backgroundColor = this.state.channels_style.doughnut[key].backgroundColor;
                            channels[key].hoverBackgroundColor = this.state.channels_style.doughnut[key].hoverBackgroundColor;
                            if(this.state.data.observations[i].channels[key] && this.state.data.observations[i].channels[key][this.state.selected]){
                                channels[key].value = parseInt(this.state.data.observations[i].channels[key][this.state.selected]);
                            }else{
                                channels[key].value = 0;
                            }
                        }
                    }
                }

                for(var key in channels){
                    this.state.doughnutData.labels.unshift(channels[key].title);
                    this.state.doughnutData.datasets[0].backgroundColor.unshift(channels[key].backgroundColor);
                    this.state.doughnutData.datasets[0].hoverBackgroundColor.unshift(channels[key].hoverBackgroundColor);
                    observations.unshift(channels[key].value);
                }

                this.state.doughnutData.datasets[0].data = observations;
                this.setState({
                    chartData: Object.assign({}, this.state.chartData, {
                        datasets: datasets
                    }),
                    doughnutData: this.state.doughnutData
                });
            }catch (e) {
                console.log(e);
            }
        }else{

            try {
                let observations = [0];
                for(let i = 0; i < this.state.data.observations.length; i++){
                    let value = 0;
                    for(let key in this.state.data.observations[i].channels){
                        if(this.state.data.observations[i].channels[key][this.state.selected]){
                            value = value + parseInt(this.state.data.observations[i].channels[key][this.state.selected]);
                        }
                    }
                    observations.push(value)
                }

                datasets = [{
                    backgroundColor: 'rgba(204, 84, 48, 0.5)',
                    borderColor: '#CC5430',
                    borderWidth: 2,
                    radius: 4,
                    pointBackgroundColor: "#ffffff",
                    pointHoverBorderColor: '#CC5430',
                    pointHoverBackgroundColor: "#ffffff",
                    data: observations
                }];
                this.setState({
                    chartData: Object.assign({}, this.state.chartData, {
                        datasets: datasets
                    })
                });
            }catch (e) {
                console.log(e);
            }
        }
        setTimeout(() => {
            this.setState({show: true});
        }, 100);
    }

    _toggleCard() {
        this.setState({selected: this.state.open ? "impressions" : this.state.selected, open: !this.state.open}, () => {
            this._updateChartData();
        });
    }

    _edit() {
        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/campaigns/history/" + this.state.data.hash);
    }

    _gotoLeads() {
        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/campaigns/history/" + this.state.data.hash + "?leads=true");
    }

    _invoice(){
        window.open("https://invoice." + dataRegister.domain + "/" + salesChannelRegister.get('name') + "/" + this.state.data.hash, '_blank');
    }

    _selectData(option) {
        if (option === "leads" && this.state.data && this.state.data.leads && this.state.data.leads > 0) {
            this._gotoLeads();
        } else {
        this.setState({selected: option}, () => {
            this._updateChartData();
        });
        }
    }

    _renderTotalClicks(data){
        let leads = 0;
        for(let i = 0; i < data.length; i++){
            for(let key in data[i].channels){
                if(data[i].channels[key].clicks){
                    leads = leads + parseInt(data[i].channels[key].clicks);
                }
            }
        }
        return leads;
    }

    _renderTotalImpressions(data){
        let impressions = 0;
        for(let i = 0; i < data.length; i++){
            for(let key in data[i].channels){
                if(data[i].channels[key].impressions){
                    impressions = impressions + parseInt(data[i].channels[key].impressions);
                }
            }
        }
        return impressions;
    }

    _renderTotalCalls(data){
        let calls = 0;
        for(let i = 0; i < data.length; i++){
            for(let key in data[i].channels){
                try {
                    calls = calls + parseInt(data[i].channels[key]['details']['clicks_by_origin']['withExtension']['Phone calls']['clicks']);
                }catch (e) {
                    calls = calls + 0;
                }
            }
        }
        if(calls < 1){
            return '...';
        }else{
            return calls;
        }
    }

    _renderPercentage(data){
        if(data.days === 0){
            return 0
        }else{
            return Math.ceil(data.duration / data.days);
        }
    }

    _renderIcon(key){
        let color = "cardSubtitleInnerIconsItemColor" + key;
        let size  =  "cardSubtitleInnerIconsItem" + key;
        return(
            <div className={
                cx(Styles.cardSubtitleInnerIconsItem,
                    {
                        [Styles[color]]: this.state.open
                    })
            }>
                <img className={Styles[size]} src={require("../../assets/images/"+key+"_logo_icon.svg")}/>
            </div>
        )
    }

    _renderLang(lang){
        if(lang === "sv"){
            return langRegister.lang() === "sv" ? "Svenska": "Swedish"
        }else if(lang === "en"){
            return langRegister.lang() === "sv" ? "Engelska": "English"
        }
    }

    _renderNumbers(x) {
        try {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        } catch (e) {
            return ("...")
        }
    }

    _renderText(item) {
        return langRegister.get("user-campaigns-running-item", item);
    }

    _renderIndustry (industry) {
        if (window.innerWidth <= 1050) {
            let input = industry;
            if (input.length > 12) {
                return input.substring(0, 12) + '...';
            } else {
                return input
            }
        } else {
            return industry
        }
    }

    render() {
        return (
            <div>
                {
                    this.state.data &&
                    <div id={this.state.id} className={
                        cx(Styles.card,
                            {
                                [Styles.cardOpen]: this.state.open
                            })
                    }>
                        <div className={Styles.cardTitle}>
                            <span>{this._renderIndustry(this.state.data.industry)}</span>&nbsp;#{this.state.data.id}
                        </div>
                        <div className={Styles.cardSubtitle}>
                            <div className={Styles.cardSubtitleInner}>
                                {
                                    /*
                                    <div className={Styles.cardSubtitleInnerText}>{this._renderLang(this.state.data.language)}</div>
                                    */
                                }
                                {
                                    this.state.data.optimization === "1" &&
                                    <div
                                        className={Styles.cardSubtitleInnerText}>{this._renderText("item_18")}</div>
                                }
                                {
                                    this.state.data.optimization === "2" &&
                                    <div
                                        className={Styles.cardSubtitleInnerText}>{this._renderText("item_17")}</div>
                                }
                                <div className={Styles.cardSubtitleInnerIcons}>
                                    {
                                        this.state.data.channels &&
                                        this.state.data.channels.map((key, i) => {

                                            return(
                                                this._renderIcon(key)
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            {
                                this.state.reseller &&
                                <div className={Styles.cardTitleCompanyName}>{this.state.data.company_name}</div>
                            }
                            {
                                this.state.reseller && salesChannelRegister.get("name") !== "yieldlock" &&
                                <div className={Styles.cardTitleRef}>{this.state.data.ref ? this.state.data.ref : ""}</div>
                            }
                        </div>
                        {
                            this.state.data.observations.length > 0 &&
                            <div onClick={() => this._toggleCard()} className={Styles.cardPlusButton}>
                                {
                                    !this.state.open &&
                                    <img className={Styles.cardPlusButtonIcon}
                                         src={require("../../assets/images/plus_sign_white.png")}/>
                                }
                                {
                                    this.state.open &&
                                    <img className={Styles.cardPlusButtonIcon}
                                         src={require("../../assets/images/minus_icon_white_small.png")}/>
                                }
                            </div>
                        }
                        <div className={
                            cx(Styles.cardLeft,
                                {
                                    [Styles.cardLeftOpen]: this.state.open
                                })
                        }>
                            {
                                this.state.time_indicator &&
                                <div onClick={() => this.setState({time_indicator: !this.state.time_indicator})} className={Styles.cardDonutChartContainer}>
                                    <svg viewBox="0 0 36 36" className={Styles.cardDonutChartContainerCircular}>
                                        <path className={Styles.cardDonutChartContainerBg}
                                              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                        />
                                        <path className={Styles.cardDonutChartContainerCircle}
                                              stroke-dasharray={"100, 100"}
                                              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                        />
                                        <text x="15.5" y="19.35" className={Styles.cardDonutChartContainerPercentage}>100</text>
                                        <text x="25.5" y="19.00" className={Styles.cardDonutChartContainerPercentageSign}>%</text>
                                        <text x="18" y="24.35"
                                              className={Styles.cardDonutChartContainerTitle}>{this._renderText("item_2")}</text>
                                    </svg>
                                </div>
                                ||
                                <div onClick={() => this.setState({time_indicator: !this.state.time_indicator})} className={Styles.cardDonutChartContainer}>
                                    <svg viewBox="0 0 36 36" className={Styles.cardDonutChartContainerCircular}>
                                        <path className={Styles.cardDonutChartContainerBg}
                                              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                        />
                                        <path className={Styles.cardDonutChartContainerCircle}
                                              stroke-dasharray={"100, 100"}
                                              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                        />
                                        <text x="14.5" y="19.35" className={Styles.cardDonutChartContainerPercentage}>{this.state.data.days}</text>
                                        <text x="22.5" y="19.4" className={Styles.cardDonutChartContainerPercentageSign}>/ {this.state.data.duration}</text>
                                        <text x="18" y="24.35" className={Styles.cardDonutChartContainerTitle}>{this._renderText("item_7")}</text>
                                    </svg>
                                </div>
                            }
                            <div className={Styles.cardDonutChartContainerInner}/>
                            {
                                this.state.data.status !== "AWAITING_PAYMENT" &&
                                <div onClick={() => this._edit()} className={
                                    cx(Styles.cardEditButton,
                                        {
                                            [Styles.cardEditButtonOpen]: this.state.open,
                                        })
                                }>
                                    {this._renderText("item_1")}
                                </div>
                            }
                            {
                                this.state.data.status === "AWAITING_PAYMENT" &&
                                <div onClick={() => this._invoice()} className={cx(Styles.cardEditButton, Styles.cardEditButtonPayment)}>
                                    {this._renderText("item_11")}
                                </div>
                            }
                            <div className={Styles.cardStatusContainer}>
                                <div className={Styles.fwdStatusContainer}>
                                    {
                                        this.state.data.broker_image && this.state.inhouse &&
                                        <div className={Styles.brokerContainer}><div style={{backgroundImage: "url(" + this.state.data.broker_image + ")"}} className={Styles.brokerImage}></div></div>
                                    }
                            {
                                this.state.data.redirect &&
                                <div className={Styles.fwdStatus}>
                                    <img className={Styles.fwdStatusIcon} src={require("../../assets/images/arrow_forward.svg")}/>
                                </div>

                            }
                            {
                                this.state.data.redirect && this.state.data.landingpage &&
                                <div className={Styles.fwdStatusContainerSpace}/>
                            }
                            {
                                this.state.data.landingpage && !this.state.data.landingpage_data.expired &&
                                <div className={Styles.fwdStatus}>
                                    <img className={Styles.fwdStatusIcon} src={require("../../assets/images/link_grey.svg")}/>
                                </div>
                            }
                            {
                                this.state.data.landingpage && this.state.data.landingpage_data.expired &&
                                <div className={Styles.fwdStatusWarning}>
                                    <img className={Styles.fwdStatusIcon} src={require("../../assets/images/link_warning.svg")}/>
                                </div>
                            }
                            </div>
                            </div>
                            {
                                false &&
                                <div className={Styles.cardStatusContainer}>
                                    <div className={
                                        cx(Styles.cardStatus,
                                            {
                                                [Styles.cardStatusPending]: true
                                            })
                                    }>
                                        <div className={
                                            cx(Styles.cardStatusDot,
                                                {
                                                    [Styles.cardStatusPending]:true
                                                })
                                        }>
                                            &#9679;
                                        </div>
                                        <div className={
                                            cx(Styles.cardStatusTitle,
                                                {
                                                    [Styles.cardStatusPending]: true
                                                })
                                        }>
                                            completed
                                        </div>
                                        {
                                            this.state.data.redirect && this.state.data.landingpage &&
                                            <div className={Styles.fwdStatus}>
                                                <img className={Styles.fwdStatusIcon} src={require("../../assets/images/arrow_forward.svg")}/><span className={Styles.iconSpace}></span><img className={Styles.fwdStatusIcon} src={require("../../assets/images/link_grey.svg")}/>
                                            </div>
                                        }
                                        {
                                            this.state.data.redirect && !this.state.data.landingpage &&
                                            <div className={Styles.fwdStatus}>
                                                <img className={Styles.fwdStatusIcon} src={require("../../assets/images/arrow_forward.svg")}/>
                                            </div>
                                        }
                                        {
                                            !this.state.data.redirect && this.state.data.landingpage &&
                                            <div className={Styles.fwdStatus}>
                                                <img className={Styles.fwdStatusIcon} src={require("../../assets/images/link_grey.svg")}/>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            <div className={Styles.cardLeftInner}>
                                {
                                    this.state.show && this.state.data.observations.length > 0 &&
                                    <Line
                                        ref={ref => this.chartInstance = ref && ref.chartInstance}
                                        data={this.state.chartData}
                                        options={this.state.options}
                                    />
                                }
                            </div>
                            <div style={{width: (100 - this.state.percentage) + "%"}} className={Styles.cardLeftOverlay}/>
                        </div>
                        <div className={
                            cx(Styles.cardRight,
                                {
                                    [Styles.cardRightOpenMobile]: this.state.open
                                })
                        }>
                            <div onClick={() => this._selectData("impressions")} className={
                                cx(Styles.cardRightImpressions,
                                    {
                                        [Styles.cardRightOpen]: this.state.open
                                    })
                            }>
                                <div className={Styles.cardRightImpressionsInner}>
                                    <div className={Styles.cardRightImpressionsInnerTitle}>
                                        {this._renderText("item_3")}
                                    </div>
                                    <div className={Styles.cardRightImpressionsInnerValue}>
                                        {this._renderNumbers(this._renderTotalImpressions(this.state.data.observations))}
                                    </div>
                                </div>
                                {
                                    this.state.selected === "impressions" &&
                                    <div className={Styles.selector}/>
                                }
                            </div>
                            <div onClick={() => this._selectData("clicks")} className={
                                cx(Styles.cardRightClicks,
                                    {
                                        [Styles.cardRightOpen]: this.state.open
                                    })
                            }>
                                <div className={Styles.cardRightClicksInner}>
                                    <div className={Styles.cardRightClicksInnerTitle}>
                                        {this._renderText("item_4")}
                                    </div>
                                    <div className={Styles.cardRightClicksInnerValue}>
                                        {this._renderNumbers(this._renderTotalClicks(this.state.data.observations))}
                                    </div>
                                </div>
                                {
                                    this.state.selected === "clicks" &&
                                    <div className={Styles.selector}/>
                                }
                            </div>
                            {
                                this.state.open && this.state.data.observations.length > 0 &&
                                <div className={
                                    cx(Styles.cardRightDoughnut,
                                        {
                                            [Styles.cardRightOpen]: this.state.open
                                        })
                                }>
                                    <Doughnut width={100} height={100} options={this.state.doughnutOptions} data={this.state.doughnutData}/>
                                    {
                                        salesChannelRegister.get("name") !== "yieldlock" && (this.state.data.engagement > 0 || this.state.data.reactions > 0) &&
                                        <img className={Styles.sectionThreeLeftTopShareMobileHeart}
                                             src={require('../../assets/images/heart_red.svg')}/>
                                    }
                                    {
                                        salesChannelRegister.get("name") === "yieldlock" && (this.state.data.engagement > 0 || this.state.data.reactions > 0) &&
                                        <img className={Styles.sectionThreeLeftTopShareMobileHeart}
                                             src={require('../../assets/images/heart_red.svg')}/>
                                    }
                                    {
                                        (this.state.data.engagement > 0 || this.state.data.reactions > 0) &&
                                        <div className={Styles.containerImageEngagement}>
                                            {this._renderNumbers((parseInt(this.state.data.engagement) + parseInt(this.state.data.reactions)))}
                                        </div>
                                    }
                                </div>
                            }
                            {
                                this.state.open && (!this.state.data.leads || (this.state.data && this.state.data.leads && this.state.data.leads < 1)) &&
                                <div onClick={() => this._selectData("call")} className={
                                    cx(Styles.cardRightImpressions,
                                        {
                                            [Styles.cardRightOpen]: this.state.open
                                        })
                                }>
                                    <div className={Styles.cardRightImpressionsInner}>
                                        <div className={Styles.cardRightImpressionsInnerTitle}>
                                            {this._renderText("item_5")}
                                        </div>
                                        <div className={Styles.cardRightImpressionsInnerValue}>
                                            {this._renderNumbers(this._renderTotalCalls(this.state.data.observations))}
                                        </div>
                                    </div>
                                    {
                                        this.state.selected === "call" &&
                                        <div className={Styles.selector}/>
                                    }
                                </div>
                            }
                            {
                                this.state.open && this.state.data && this.state.data.leads && this.state.data.leads > 0 &&
                                <div onClick={() => this._selectData("leads")} className={
                                    cx(Styles.cardRightImpressions,
                                        {
                                            [Styles.cardRightOpen]: this.state.open
                                        })
                                }>
                                    <div className={Styles.cardRightImpressionsInner}>
                                        <div className={Styles.cardRightImpressionsInnerTitle}>
                                            {this._renderText("item_16")}
                                        </div>
                                        <div className={Styles.cardRightImpressionsInnerValue}>
                                            {this.state.data.leads}
                                        </div>
                                    </div>
                                    {
                                        this.state.selected === "leads" &&
                                        <div className={Styles.selector}/>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        );
    }
}


export default userCampaignsHistoryItem;


// WEBPACK FOOTER //
// ./src/components/user-campaigns-history-item/component.js